import { getPlainText, getRichText
// @ts-ignore module not typed
} from '../../../common-message-format/operators/commonMessageFormatGetters';
import { getHasReplies } from '../../../common-message-format/operators/emailMetadataGetters';
import { lruMemoize } from '../../../util/lruMemoize';
import { getEvaluatedTextContent } from './getEvaluatedTextContent';
export const hasTextContent = lruMemoize(message => {
  // @ts-ignore - message may not have all CommonMessage properties but getHasReplies will return undefined if it doesn't.
  const hasReplies = !!getHasReplies(message);

  // short circuit to avoid any further processing
  if (hasReplies) {
    return true;
  }
  const html = getRichText(message) || getPlainText(message);
  return Boolean(html && html.length && getEvaluatedTextContent(html));
});